import { requiredStrategy } from '../core';
import { creditCardNumberFormatStrategy } from './credit-card-number-format-strategy';

export const creditCardNumberStrategy = (value: string) => {
  return requiredStrategy(value) && creditCardNumberFormatStrategy(value);
};
